let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3px1j")).then(() => parcelRequire('54f3C'));